import script from "./IMatchEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./IMatchEvent.vue?vue&type=script&setup=true&lang=js"

import "./IMatchEvent.vue?vue&type=style&index=0&id=1ca886e0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca886e0"]])

export default __exports__